module.exports = {
  BookingNo: '委托编号',
  JobNo: '业务编号',
  ContainerLoadType: '整拼类型',
  Electric: '是否带电',
  ElectricCol: '带电',
  Magnetic: '是否带磁',
  MagneticCol: '带磁',
  Powdery: '是否粉末',
  PowderyCol: '粉末',
  Liquid: '是否液体',
  LiquidCol: '液体',
  DomesticWarehouse: '收货仓库',
  PreAmazonWhTime: '预期入亚马逊仓时间',
  ServiceChannel: '服务渠道',
  WarehouseCode: '海外仓编码',
  RemoteWarehouse: '是否偏远仓',
  ShippingType: '运输方式',
  DestinationDistribution: '目的地配送方式',
  overseaWarehouse: '国外仓',
  IncoTerm: '贸易条款',
  PoNumber: 'PO（原单号）',
  ShipmentId: 'Shipment Id',
  ReferenceId: 'Reference Id',
  ChargingMethod: '计费方式',
  LclMethod: '拼箱方式',
  ValueAddedServices: '增值服务',
  EoriNo: 'EORI/企业号',
  TaxnoType: '税号类型',
  VatNo: 'VAT/税号',
  TaxRegisterCountry: 'VAT注册国家',
  TaxRegisterAddress: 'VAT注册地址',
  TaxCompany: 'VAT公司（英文名）',
  PreWarehousingTime: '预计进仓时间',
  QuantityContract: '总件数（委托）',
  WeightContract: '总重量（委托）',
  CubageContract: '总体积（委托）',
  VolumetricWeight: '材积（委托）',
  ChargedWeight: '计费重量（委托）',
  QuantityActual: '总件数（实际）',
  WeightActual: '总重量（实际）',
  CubageActual: '总体积（实际）',
  QuantityCharge: '总件数（计费）',
  WeightCharge: '总重量（计费）',
  CubageCharge: '总体积（计费）',
  BubbleCountingRatio: '计泡系数',
  BubbleSplittingRatio: '分泡比例',
  PickupService: '上门提货',
  PickupTime: '提货时间',
  PickupDoor: '提货门点',
  DoorMan: '联系人',
  DoorManTel: '联系电话',
  DoorAddress: '门点地址',
  CustomerRequire: '客户要求',
  SubmitState: '提交状态',
  SubmitBy: '提交人',
  importSingleOrder: '单个订单导入',
  batchImportOrder: '批量订单导入',
  downloadSingleImportTemplate: '下载单个导入模版',
  downloadBatchImportTemplate: '下载批量导入模版',
  SubmitDate: '提交时间',
  VerifyState: '预审状态',
  VerifyBy: '预审人',
  VerifyDate: '预审时间',
  UseNewNo: '生成新的业务编号',
  BookingAudit: '订单审核',
  ShippingTypeCannotBeEmpty: '运输方式不能为空',
  ChargingMethodCannotBeEmpty: '计费方式不能为空',
  DomesticWarehouseCannotBeEmpty: '收货仓库不能为空',
  WarehouseCodeCannotBeEmpty: '亚马逊仓库编号不能为空',
  ContainerLoadTypeCannotBeEmpty: '整拼类型不能为空',
  OperateTypeCannotBeEmpty: '操作模式不能为空',
  BookingTermCannotBeEmpty: '订舱性质不能为空',
  VerifyRefuseReason: '审核拒绝原因',
  ReverifyRefuseReason: '复核拒绝原因',
  CustomerId: '委托单位',
  LoadingPortCode: '起运港',
  Packing: '包装类型',
  SingleImport: '导入一个FBA订单',
  Op: '操作',
  Sales: '销售',
  Csr: '客服',
  Dc: '单证',
  CreatedBy: '创建人',
  DateCreated: '创建日期',
  ExpressCompany: '快递公司',
  ExpressNo: '快递单号',
  AmazonWarehouseCode: '亚马逊仓库编码',
  OperationStatusOfForeignWarehouse: '国外仓操作状态',
  Cargo_PolStation: '始发站（铁路）',
  quotationStatus: '报价状态',
  quotationObject: '报价对象',
  hasJob: '是否引入订单',
  cannotDeleteAddedService: '不允许删除已经被业务使用的增值服务！',
  changeChannel: '当前服务渠道未维护当前客户级别的报价，系统无法自动预估费用，是否继续？',
  cargoTypeNotExist: '当前服务渠道的可接货物不包含{0}，请更新货物类型！',
  warehouseCodeNotExist: '当前服务渠道的目的地不包含{0}，请更新目的地！',
  changeWarehouseCode: '目的地发生更改，是否刷新原来服务渠道所在区产生的费用？',
  changeCustomer: '委托单位发生更改是否刷新原来服务渠道所在客户级别产生的费用？',
  changeChargeWeight: '计费重量发生更改，是否刷新原有按计费重量为单位的费用? 已经做账单、开票、付款申请、销账的费用不会更新',
  refreshCharge: '服务渠道发生更改，是否需要刷新原有按照服务渠道生成的费用？',
  channelInfoCannotChange: '该服务渠道的{0}不能修改。',
  changeVerifyShippingType: '{0}该服务渠道只支持{1}运输。',
  changeVerifyMultipleShippingType: '勾选数据中含有维护服务渠道的订单，不能修改运输方式。',
  otherOverseaWarehouse: '第三方海外仓'
}
